var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._g(_vm._b({class:("ep-combobox ep-combobox-" + (_vm.valid ? 'valid' : 'invalid')),style:({
    height: '50px',
    borderRadius: '8px',
    boxShadow: 'none'
  }),attrs:{"tabindex":_vm.field.tabIndex,"items":_vm.choices,"item-text":"name","loading":_vm.field.loading,"placeholder":_vm.field.placeholder,"outlined":"","persistent-hint":"","value":_vm.value}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }